import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CheckedOutByYou12Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M939 171q129 0 248 33t224 95 190 147 147 190 95 224 34 249q0 129-33 248t-95 224-147 191-190 147-224 95-249 34q-129 0-249-33t-224-95-190-147-147-190-95-225-34-249q0-129 33-248t95-224 148-190 190-147 224-95 249-34zm426 1365V853h-170v361L673 693 522 843l522 522H683v171h682z" />
    </svg>
  ),
  displayName: 'CheckedOutByYou12Icon',
});

export default CheckedOutByYou12Icon;
